export default "__VITE_ASSET__d867a496__"